import { useCallback, useState } from "react";
import CustomersService from "../../../services/customers";

export const useGetCustomerInfo = (setData: React.Dispatch<React.SetStateAction<any[]>>) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const search = useCallback(
    (num: number) => {
      setIsLoading(true);

      CustomersService.searchByNumber(num)
        .then((res) => {
          setIsLoading(false);

          setData((prev: any) => {
            return [
              ...prev,
              {
                name: res.name,
                number: num,
                value: num,
                id: res.id
              }
            ];
          });
        })
        .catch(() => setIsLoading(false));
    },
    [setIsLoading, setData]
  );

  return { isLoading, search };
};
